import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-web-storage';
import { Subject } from 'rxjs';
import { MDBModalRef } from '../../../app/shared/services/mdb-modal-stub.service';
import { AuthService } from '../../core/services/auth.service';
import { UserPersistenceService } from '../../core/services/userPersistence.service';
import { IDropdownData } from '../../shared/interfaces/calculator.interface';
import { Constants } from '../../shared/models/constants';
import { Enums } from '../../shared/models/enums';
import ModalLandingPage from '../../shared/schemas/modals/modalLandingPagePreference.json';
import { FormControlService } from '../../shared/services/form-control.service';
import { FormGroupGenerationService } from '../../shared/services/form-group-generation.service';
import { ToastService } from '../../shared/services/toast.service';
import { CheckboxComponent } from '../../shared/widgets/form/checkbox/checkbox.component';
import { SelectComponent } from '../../shared/widgets/form/select/select.component';

@Component({
    selector: 'ifc-modal-landing-page-preference',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './modal-landing-page-preference.component.html',
    styleUrls: ['./modal-landing-page-preference.component.scss'],
    standalone: true,
    imports: [SelectComponent, CheckboxComponent, MatButton]
})
export class ModalLandingPagePreference implements OnInit {

    form: FormGroup;
    action: Subject<any> = new Subject();
    emailSent = false;
    schema = ModalLandingPage;
    confirmationStatus = Enums.confirmationStatus;
    userPasswordReset = false;
    passwordExpired = false;
    landingPageDropDown: Array<IDropdownData>
    landingPageName: string;

    constructor(
        public modalRef: MDBModalRef,
        public userPersistenceService: UserPersistenceService,
        private formControlService: FormControlService,
        private fb: FormBuilder,
        private formGroupGenerationService: FormGroupGenerationService,
        private authService: AuthService,
        private toastService: ToastService,
        private router: Router,
        private localStorageService: LocalStorageService,

        private cdr: ChangeDetectorRef) { }

    ngOnInit() {
        this.form = this.fb.group(this.formGroupGenerationService.createFormGroup(this.schema));
        this.form.controls.hideLandingPagePopUp.setValue(false);
        this.form.controls.landingPage.setValue(this.landingPageName);
        //this.updateControlLabel();
    }


    onCancelClick() {
        this.modalRef.hide();
        this.action.next({ status: this.confirmationStatus.cancel });
    }

    onSaveClick() {
        this.authService.saveLandingPageDetails(this.form.controls.landingPage.value, this.form.controls.hideLandingPagePopUp.value).subscribe(response => {
            this.localStorageService.set(Constants.LANDING_URL, response);
            this.action.next({ status: this.confirmationStatus.ok, data: response });
            this.toastService.success('Preference saved successfully.');
            this.modalRef.hide();
        
            this.cdr.markForCheck();});
        
    }
}
